import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuAsideService, SubheaderService } from '../../../../core/_base/layout';
import { MenuItemModel } from '../../../models/menu-item.model';
import { MatDialog } from '@angular/material';
import { NewItemPopup } from '../../../component/popup/new-item/new-item.popup';
import { Category, MenuSectionService } from '../../../../provider/menu-section.service';
import { MenuCategoryModel } from '../../../models/menu-category.model';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModel } from '../../../../core/_base/layout/models/translate.model';
import { LanguageTranslatePopup } from '../../../component/popup/language-translate/language-translate.popup';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { ItemService } from '../../../../provider/item.service';
import { TranslationService } from '../../../../provider/translation.service';
import { AWSService } from '../../../../provider/aws.service';
import { UserService } from '../../../../provider/user.service';
import { ItemPopup } from '../../../component/popup/item/item.popup';
import { ChangeImagePopup } from '../../../component/popup/change-image/change-image.popup';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'kt-menu-section',
  templateUrl: './menu-section.page.html',
  styleUrls: ['./menu-section.page.scss']
})
export class MenuSectionPage implements OnDestroy, AfterViewInit, OnInit {
  MenuSectionID: number;
  newCategory = '';
  private subs: Subscription[] = [];
  currentMenuCategoryModel: MenuCategoryModel;
  data: MenuCategoryModel = new MenuCategoryModel();
  time = new Date().getTime();

  showImage: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private menuAsideService: MenuAsideService,
    public myService: MenuSectionService,
    public dialog: MatDialog,
    private router: Router,
    public tra: TranslationService,
    private itemService: ItemService,
    private awsService: AWSService,
    private userService: UserService,
    private subHeaderService: SubheaderService,
    private http: HttpClient
  ) {
    this.menuAsideService.pathname$.next(window.location.pathname);
  }

  async ngOnInit() {
    this.MenuSectionID = Number(this.route.snapshot.params.id);
    await this.myService.getDatas(this.MenuSectionID);
    this.myService.getDialogData(this.MenuSectionID);

    if (this.MenuSectionID == 121) {
      const sub2 = this.subHeaderService.poisDataChange$.subscribe(
        (data) => {
          if (data != undefined) {
            this.myService.getDatas(this.MenuSectionID);
          }
        }
      );
      this.subs.push(sub2);
    }

    this.router.navigateByUrl(`/home/menu-item/${this.myService.record_change$.getValue()[0].items[0].id}`);
  }

  ngOnDestroy(): void {
    this.subs.forEach(x => x.unsubscribe());
  }

  ngAfterViewInit() {
    try {
      var item = this.myService.record_change$.getValue()[0].category[0];

      this.http.get('https://b1development.s3.eu-central-1.amazonaws.com/icibotV2/' + item.category.hotel_id + '/Categories/' + item.category.id + '.jpeg')
        .subscribe((resp) => {

        }, err => {
          this.showImage = false;
        });
    } catch (error) {
      this.showImage = false;
    }

  }

  Save() {
    this.myService.addCategory(this.newCategory, this.MenuSectionID);
    this.newCategory = '';
  }

  Delete(item: Category) {
    const datas = this.myService.record_change$.getValue();
    if (datas.length <= 1) {
      console.log('silinemez');
      return;
    }
    this.myService.deleteCategory(item, 0);
  }

  changeCategory(data: MenuItemModel, newCategoryID: number) {
    this.myService.setData(data, newCategoryID);
  }

  editClick(data: MenuItemModel) {
    this.router.navigateByUrl('/home/menu-item/' + data.id);
  }

  openDialog(categoryID: number) {
    const dialogData = this.myService.dialag_change.getValue();
    // console.log(dialogData);
    if (dialogData == undefined || dialogData.items.length == 0) {
      // dialogData = {section_id: 0, section_name: '', description: '', items: []};
      const dialogRef = this.dialog.open(ItemPopup, { width: '1400px' });
      dialogRef.afterClosed().subscribe(result => {
        if (!(result == false || result == undefined)) {
          if (isNotNullOrUndefined(result.Item)) {
            this.postItem(result, categoryID);
          } else {
            const menuItem: MenuItemModel = new MenuItemModel();
            menuItem.name = result.name;
            menuItem.image_url = result.img;
            this.myService.setData(menuItem, categoryID);
          }
        }
      });
    } else {
      dialogData.section_name = this.myService.section_change$.getValue().title;
      const dialogRef = this.dialog.open(NewItemPopup, { width: '1000px', height: '700px', data: dialogData });
      const sub = dialogRef.afterClosed().subscribe(result => {
        if (!(result == false || result == undefined)) {
          if (isNotNullOrUndefined(result.Item)) {
            this.postItem(result, categoryID);
          } else {
            const menuItem: MenuItemModel = new MenuItemModel();
            menuItem.name = result.name;
            menuItem.image_url = result.img;
            this.myService.setData(menuItem, categoryID);
          }

        }
      });
      this.subs.push(sub);
    }

  }

  postItem(result, categoryID: number) {
    this.myService.postData(result.Item, categoryID).subscribe(
      (datas: MenuItemModel[]) => {
        this.myService.getDatas(datas[0].menu_section_id);
        try {
          result.TagDatas.forEach(x => {
            x.table_record_id = datas[0].id;
            this.itemService.postTagData(x);
          });
        } catch (e) {
          console.log('Tagler eklenirken bir hata oluştu: ' + e.ERROR);
        }
        try {
          if (result.ImageDatas.length > 0) {
            let priority = 1;
            // tslint:disable-next-line:no-shadowed-variable
            result.files.forEach(x => {
              const imageName = datas[0].id + '_' + priority.toString() + '.jpeg';
              this.awsService.uploadImage(x, this.userService.record_change$.getValue().app_hotel_id, 'Items', imageName).subscribe(
                (resp: any) => {
                  if (imageName == datas[0].id + '_1.jpeg') {
                    datas[0].image_url = resp.link;
                    this.itemService.putItem(datas[0]);
                    this.myService.getDatas(datas[0].menu_section_id);
                  }
                }, (err) => {
                  console.log(err);
                },
                () => {
                  this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Items', 0);
                }
              );
              priority++;
            });
          }
        } catch (e) {
          console.log('Resimler eklenirken bir hata oluştu: ' + e.ERROR);
        }
      },
      (err) => console.log(err)
    );
  }

  removeClick(data: MenuItemModel) {
    this.myService.deleteData(data);
  }


  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'MenuCategory') {
      this.currentMenuCategoryModel = baseData;
    } else {
      this.currentMenuCategoryModel = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.myService.putCategory(this.data);
      if (this.currentMenuCategoryModel != undefined) {
        this.myService.putCategory(this.currentMenuCategoryModel);
      }
    });

  }

  changeImage(data: MenuCategoryModel) {
    this.currentMenuCategoryModel = data;
    const dialogRef = this.dialog.open(ChangeImagePopup, { width: '700px', data });
    dialogRef.afterClosed().subscribe(() => {
      this.myService.putCategory(this.data);
      if (this.currentMenuCategoryModel != undefined) {
        this.myService.putCategory(this.currentMenuCategoryModel);
      }
    });
  }

  drop(event: CdkDragDrop<string[]>, items: MenuItemModel[]) {
    const currentIndex = event.currentIndex;
    const previousIndex = event.previousIndex;

    if (currentIndex == previousIndex) {
      return;
    }
    items[previousIndex].priority = items[currentIndex].priority;
    if (currentIndex > previousIndex) {
      for (let i = previousIndex; i < currentIndex; i++) {
        items[i + 1].priority = items[i + 1].priority - 1;
      }
    } else {
      for (let i = currentIndex; i < previousIndex; i++) {
        items[i].priority = items[i].priority + 1;
      }
    }
    items.forEach(x => {
      this.itemService.putItem(x);
    });
    this.myService.getDatas(this.MenuSectionID);
  }

  getImeges(data: MenuItemModel) {
    this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Items', data.id);
  }
}
